import { Modal } from "react-bootstrap";
import { showSuccessToast,showErrorToast } from "../../../components/Toast/Toaster";
import { useFormik } from "formik";
import { object, string, number } from 'yup';
import SearchInput from '../../../components/dropdown/autoCompleteInputComponent';
import { useCodAutomationStore } from '../../../store/CodAutomation/codAutomationStore';
const AdjustmentEntryModal = ({
  setShowModal,
  title = "Add Adjustment Entry",
  summaryId,
  fetchPageData,
  // fetchPayable,
  // generateRecordId
}) => {

  const saveAdjustmentEntryApi = useCodAutomationStore((state) => state?.saveAdjustmentEntry);
  const addEntry = useFormik({
    initialValues: {
      remarks: "",
      amount: "",
      type:"",
      summaryId: summaryId
    },
    /*validationSchema: object({
      remark: string().trim().required("Remarks is required"),
      amount: number().required("Amount is required")    
    }),*/

    onSubmit: async (values, { resetForm }) => {

     await saveAdjustmentEntryApi(values).then((response) => {
          if (response?.data?.status == "SUCCESS") {
            showSuccessToast("Adjustment entry added");
            resetForm();
            setShowModal(false);
            fetchPageData();
            // let data = {...response?.data.data,
            //   customer : response?.data.data?.customerAccount
            // }
            // console.log(data);
            // console.log("generatedId : "+generateRecordId(data))
            // fetchPayable(generateRecordId(data),data.customer);

          } else if (response?.data?.error?.length > 0) {
            showErrorToast(response?.data?.error);
            resetForm();
            setShowModal(false);
         
          } else {
            const errorMessage = "Something went wrong. Status : "+response?.status
            showErrorToast(errorMessage);
            resetForm();
            setShowModal(false);
          }
        });
    },
  });


  const saveEntry = (e) => {
      addEntry.submitForm();
  };
  return (
    <>
      <Modal.Header closeButton>
        <h4 className="fontSize16 blackText fontWeight500">{title}</h4>
      </Modal.Header>
      <div className="modelScrollVehicleVendors">
        <Modal.Body>
          <form onSubmit={addEntry.handleSubmit}>
            <div className="row margin-top-10">
              <div className="col-md-6">
              
                <div className="row alignItemCenter mb_12">
                  <div className="col-md-12">
                    <label className="fontSize14 mb_12 menacingCloudsText fontWeight500">
                      Type
                      <span className="bloodDonortext fontWeight600 fontSize16">
                        *
                      </span>
                    </label>
                    <SearchInput
                            id="type"
                            label="type"
                            name="type"
                            applySelectedStyles={true}
                            options={[{name:"Credit Note",value:"CN"},{name:"Debit Note",value:"DN"}]}
                            getOptionLabel={(option) => option.name}
                            getOptionValue={(option) => option.value}
                            handleChange={(selectedOption) => {
                                addEntry.setFieldValue("type", selectedOption.value);
                                
                            }}
                            placeholder="Entry type"
                            className={
                                'mainInput withSearchIcon'
                            }
                        />
                  </div>

                  {addEntry.touched.app &&
                  addEntry.errors.app ? (
                    <p className="requiredText">
                      {addEntry.errors.remarks}
                    </p>
                  ) : null}
                </div>
              </div>
            <div className="col-md-6">
              
                <div className="row alignItemCenter mb_12">
                  <div className="col-md-12">
                    <label className="fontSize14 mb_12 menacingCloudsText fontWeight500">
                      Remarks
                      <span className="bloodDonortext fontWeight600 fontSize16">
                        *
                      </span>
                    </label>
                    <input
                      type="text"
                      placeholder="Remarks"
                      value={addEntry.values.remarks}
                      onChange={(e) => {
                        addEntry.setFieldValue("remarks", e.target.value);
                      }}
                      name="remarks"
                      className="mainInput"
                    />
                  </div>

                  {addEntry.touched.app &&
                  addEntry.errors.app ? (
                    <p className="requiredText">
                      {addEntry.errors.remarks}
                    </p>
                  ) : null}
                </div>
              </div>
              <div className="col-md-6">
                <div className="row alignItemCenter mb_12">
                  <div className="col-md-12">
                    <label className="fontSize14 mb_12 menacingCloudsText fontWeight500">
                      Amount
                      <span className="bloodDonortext fontWeight600 fontSize16">
                        *
                      </span>
                    </label>
                    <input
                      type="number"
                      placeholder="0.0"
                      value={addEntry.values.amount}
                      onChange={(e) => {
                        addEntry.setFieldValue("amount", e.target.value);
                      }}
                      name="amount"
                      className="mainInput"
                    />
                  </div>
                  {addEntry.touched.module &&
                  addEntry.errors.module ? (
                    <p className="requiredText">
                      {addEntry.errors.module}
                    </p>
                  ) : null}
                </div>
              </div>
            </div>
          </form>
        </Modal.Body>
      </div>
      <Modal.Footer style={{ justifyContent: "center" }}>
        <div className="displayFlex alignItemCenter justifyContent_end gap_16">
          <button className="blue_btn" type="button" onClick={ (e)=> saveEntry(e)}>
          Add
          </button>
          <button className="cancel_btn" onClick={() => setShowModal(false)}>
            Cancel
          </button>
        </div>
      </Modal.Footer>
    </>
  );
};

export default AdjustmentEntryModal;
